import { Component, OnInit, NgZone, OnDestroy, ViewChild, ElementRef } from "@angular/core";
import { Download, BundledDownloads, Downloads, Product, ProductDetail, GetOemKeyResponse, RawProductData, ContentService, CheckoutService } from "@mypxplat/xplat/core";
import { BaseComponent, UserService, ProductService, HelperService, WindowService, GAService, environment, EventBusService } from "@mypxplat/xplat/core";
import { ActivatedRoute, Router, NavigationEnd, NavigationExtras } from "@angular/router";
import * as moment from "moment";
import {
  ActivateOfflineComponent,
  TransferLicenseComponent,
  UpgradeSoftwareComponent,
  ManageActivationsComponent,
  RegisterProductComponent,
  FirmwareInstructionsComponent,
  IlokComponent,
  RedeemHardwareOfferComponent,
  RegisterSuccessSplashComponent,
  Studioone6GracePeriodComponent,
  UpgradeSoftwareStripeComponent,
} from "../modals";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { AppService, AvoService, BetaService, FirebaseService } from "@mypxplat/xplat/web/core";
import natsort from "natsort";
import { ClipboardService } from "ngx-clipboard";
import { filter, take } from "rxjs/operators";
import { ProductDownloadsComponent } from "../product-downloads/product-downloads.component";

@Component({
  selector: "myp-shared-product-detail",
  templateUrl: "product-detail.component.html",
})
export class ProductDetailComponent extends BaseComponent implements OnInit, OnDestroy {
  @ViewChild("productDownloads") productDownloads: ProductDownloadsComponent;
  @ViewChild("prodDetailTitle") prodDetailTitle: ElementRef;
  @ViewChild("prodDetailHead") prodDetailHead: ElementRef;
  public rawProduct: RawProductData;
  public product: any;
  public details: ProductDetail;
  public group: Array<Product>;
  public loading: boolean = false;
  public selectedVideo: any = false;
  public selectedGroupProduct;
  public productImage: string;
  public hasThirdPartyKeys: boolean = false;
  public children: Array<Product>;
  public optionCards: Array<Product>;
  public downloads: Downloads;
  public downloadSections: Array<any>;
  public displayedDownloadSection: any;
  public resources: any;
  public resourcesSections: Array<any>;
  public displayedResourcesSection: string;
  public bundledDownloads: BundledDownloads;
  public installFile: any;
  public s1OrNotion: boolean;
  public isS15: boolean;
  public isS16: boolean;
  public showAllSystems: boolean = false;
  public myOs: string;
  public showKeyActions: boolean = true;
  public computerName: string;
  public routerEvents: any;
  public installMethods: Array<string>;
  public shouldShowSphereRedeem: boolean = false;
  public features: string;
  public featuresCollapsed: boolean = false;
  public samplesCollapsed: boolean = false;
  public downloadsCollapsed: boolean = false;
  public childrenCollapsed: boolean = false;
  public resourcesCollapsed: boolean = false;
  public samplePrefix = "https://pae-web.presonusmusic.com/uploads/products/";
  public env = environment;
  public isNotionMobile: boolean;
  public viewingOffers: boolean = false;
  public hashFragment: string;
  public couponParam: string;
  public subscriptionOnly: boolean;
  constructor(
    userService: UserService,
    private _route: ActivatedRoute,
    public eventBusService: EventBusService,
    public productService: ProductService,
    public helperService: HelperService,
    public appService: AppService,
    private _zone: NgZone,
    public win: WindowService,
    private router: Router,
    public ga: GAService,
    private _translate: TranslateService,
    private _spin: NgxSpinnerService,
    public db: AngularFirestore,
    private _clipboardService: ClipboardService,
    public contentService: ContentService,
    public betaService: BetaService,
    public avoService: AvoService,
    public fbService: FirebaseService,
    public checkoutService: CheckoutService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.myOs = this.win.navigator.platform.indexOf("Mac") > -1 ? "mac" : "win";
    let id = this._route.snapshot.params["id"];
    const urlTree = this.router.parseUrl(this.router.url);
    this.hashFragment = urlTree.fragment;
    this.initView(id);
    this.routerEvents = this.router.events.subscribe((result) => {
      // this allows you to "navigate" to another product detail from this page
      if (result instanceof NavigationEnd) {
        this.initView(this._route.snapshot.params["id"]);
      }
    });
  }

  ngOnDestroy() {
    if (this.routerEvents && this.routerEvents.unsubscribe) this.routerEvents.unsubscribe();
    super.ngOnDestroy();
  }

  initView(id) {
    this.product = this.productService.getProduct(id);
    if (this.product) {
      this.rawProduct = this.product.product;
      this.productImage = this.rawProduct.imageUrl;
      this.s1OrNotion = this.rawProduct.categoryId == "software" && (this.rawProduct.stringId.indexOf("studioapp") > -1 || this.rawProduct.licenseScheme == 1) ? true : false;
      this.isS15 = this.rawProduct.erpId && this.rawProduct.erpId.indexOf("STUDIOONE5") > -1;
      this.isS16 = this.rawProduct.erpId && this.rawProduct.erpId.indexOf("STUDIOONE6") > -1;
      this.isNotionMobile = this.rawProduct.stringId && this.rawProduct.stringId.indexOf("notionmobile3") > -1;
      this.setup();
    } else {
      this.productService.getProducts().subscribe((data: any) => {
        this.product = this.productService.getProduct(id);
        this.setup();
      });
    }
    if (this._route.snapshot.queryParams["upgrade"]) {
      let upgradeProduct: boolean = JSON.parse(this._route.snapshot.queryParams["upgrade"]);
      if (upgradeProduct) {
        if (this._route.snapshot.queryParams["coupon"]) {
          this.couponParam = this._route.snapshot.queryParams["coupon"];
        }
        this.showUpgrade(this.product);
      }
    }
    window.scrollTo(0, 0);
  }

  setup(force = false) {
    this.loading = true;
    if (!this.product) {
      this.goBack();
      return false;
    }
    this.productService.getProductDetails(this.product, force).subscribe((result: ProductDetail) => {
      if (!result) {
        this.goBack();
        return false;
      }
      this.details = result;
      this.fbService.handleFirestorePromise(() => {
        return this.db.doc("user_metadata/" + this.user.id).set(
          {
            products_seen: {
              [this.details.product_data.product.id]: true,
            },
          },
          { merge: true }
        );
      });
      if (!this.userService.userMetadata) {
        this.userService.userMetadata = {
          products_seen: {},
        };
      } else if (!this.userService.userMetadata.products_seen) {
        this.userService.userMetadata.products_seen = {};
      }
      this.userService.userMetadata.products_seen[this.details.product_data.product.id] = true;
      if (this.product.productType == "Subscription") this.details.product_data.productType = "Subscription";
      this.product = result.product_data;
      if (this.product.product) {
        this.rawProduct = this.product.product;
      } else {
        this.rawProduct = this.product;
      }
      this.productImage = this.rawProduct.imageUrl;
      this.s1OrNotion = this.rawProduct.categoryId == "software" && (this.rawProduct.stringId.indexOf("studioapp") > -1 || this.rawProduct.licenseScheme == 1) ? true : false;
      if (this.rawProduct.installMethod && this.rawProduct.installMethod != "none") {
        this.installMethods = this.rawProduct.installMethod.split("-");
        this.installMethods.reverse();
      }
      this.bundledDownloads = this.rawProduct.bundled_downloads;
      this.downloads = this.rawProduct.downloads;

      if (this.details.product_data.cms_info && this.details.product_data.cms_info.features) {
        for (let i in this.details.product_data.cms_info.features) {
          let featureLang = this.details.product_data.cms_info.features[i];
          if (!this.user.language_code) {
            if (featureLang.code_languages == "EN") this.features = featureLang.content;
          } else {
            if (this.user.language_code.toUpperCase() == featureLang.code_languages) this.features = featureLang.content;
          }
        }
      }

      if (this.isNotionMobile) {
        if (!this.downloads.owners_manuals) this.downloads.owners_manuals = [];
        this.downloads.owners_manuals.unshift({
          url: "https://notionmobilemanual.presonus.com",
          title: "Notion Mobile Online Manual",
          tileTitle: "Notion Mobile",
          type: "link",
        });
      }

      this.downloadSections = [];
      if (this.details.product_data.firmware_list && this.details.product_data.firmware_list.length) {
        this.downloads.firmware = this.details.product_data.firmware_list;
      }
      for (let i in this.downloads) {
        if (i != "installers") {
          this.downloadSections.push({
            value: i,
            displayed: false,
          });
        }
      }
      if ((this.isS15 || this.isS16) && this.downloads.owners_manuals) {
        if (!this.downloads.owners_manuals.length) this.downloads.owners_manuals = [];
        this.downloads.owners_manuals.unshift({
          url: "https://s1manual.presonus.com",
          title: "Studio One Online Manual",
          tileTitle: "Studio One",
          type: "link",
        });
      }

      if (this.rawProduct.partnerName == "third_party" && !this.rawProduct.partnerKey) {
        this.showKeyActions = false;
      }

      this.resources = {};
      if (this.details.product_data.cms_info && this.details.product_data.cms_info.learn_resources && this.details.product_data.cms_info.learn_resources.length)
        this.resources.learn = this.details.product_data.cms_info.learn_resources;
      if (this.details.product_data.cms_info && this.details.product_data.cms_info.videos && this.details.product_data.cms_info.videos.length)
        this.resources.videos = this.details.product_data.cms_info.videos;
      if (this.resources.videos && this.resources.videos.length) {
        let sorter = natsort();
        this.resources.videos.sort(function (a, b) {
          return sorter(a.title_videos, b.title_videos);
        });
      }
      if (this.details.product_data.cms_info && this.details.product_data.cms_info.accessories && this.details.product_data.cms_info.accessories.length)
        this.resources.accessories = this.details.product_data.cms_info.accessories;
      if (this.details.product_data.cms_info && this.details.product_data.cms_info.related_products && this.details.product_data.cms_info.related_products.length) {
        this.resources.related_products = [];
        this.details.product_data.cms_info.related_products.forEach((item) => {
          if (item.url || (item.nav_id && this.productService.productsByErpIDs[item.nav_id])) this.resources.related_products.push(item);
        });
      }

      this.resourcesSections = [];
      if (this.details.product_data.videos && this.details.product_data.videos.length) {
        this.resourcesSections.push({
          value: "videos",
          displayed: false,
        });
      }
      for (let i in this.resources) {
        this.resourcesSections.push({
          value: i,
          displayed: false,
        });
      }
      this.displayDownloadSection(this.downloadSections[0]);
      this.displayResourceSection(this.resourcesSections[0]);
      this.loading = false;
      this.group = this.productService.productGroups[this.rawProduct.stringId];
      this.children = [];
      if (this.rawProduct.id == this.env.product_ids.s16pro) {
        if (this.group.length == 1 && this.group[0].productType == "Subscription") this.subscriptionOnly = true;
      }
      this.optionCards = [];
      this.group.sort((a, b) => {
        if (moment(a.aquired) > moment(b.aquired)) {
          return -1;
        } else if (moment(a.aquired) < moment(b.aquired)) {
          return 1;
        }
      });
      this.group.forEach((item) => {
        if (item.children) {
          if (item.children.extensions && item.children.extensions.length) this.children = [...item.children.extensions];
          if (item.children.software && item.children.software.length) this.children = [...this.children, ...item.children.software];
          if (item.children.hardware && item.children.hardware.length) this.optionCards = [...this.optionCards, ...item.children.hardware];
        }
        if (item.items && item.items.length) this.hasThirdPartyKeys = true;
        if (item.activations && item.activations.length) {
          item.activations[0].computerName = encodeURIComponent(item.activations[0].comment);
        }
        if (!item.upgraded) {
          this.shouldShowSphereRedeem = true;
        }
      });
      let studioOneChildren = [];
      this.children.forEach((item) => {
        if (item.product.stringId.indexOf("studioapp") > -1) {
          studioOneChildren.push(item);
        }
      });
      this.children = this.children.filter((item) => item.product.stringId.indexOf("studioapp") == -1);
      this.children.sort((a, b) => {
        return a.product.title > b.product.title ? 1 : -1;
      });
      this.children = [...studioOneChildren, ...this.children];

      if (this._route.snapshot.queryParams["viewoffers"] && !this.viewingOffers) {
        let offersItem: any = false;
        this.group.forEach((item) => {
          if (item.offers && item.offers.length) offersItem = item;
        });

        if (offersItem) {
          this.viewingOffers = true;
          this.openOffers(offersItem);
        } else {
          alert("You currently have no offers associated with this product.");
        }
      }

      if (this.hashFragment && this.hashFragment.indexOf("downloads_") > -1) {
        this.win.setTimeout(() => {
          let inputContainerEl = document.getElementById("product-downloads");
          if (inputContainerEl && inputContainerEl.scrollIntoView) {
            inputContainerEl.scrollIntoView({
              behavior: "smooth",
            });
            if (this.productDownloads && this.productDownloads.displayDownloadSection) this.productDownloads.displayDownloadSection(false, this.hashFragment.split("downloads_")[1]);
          }
        }, 800);
      }

      this.avoService.avoInitted$.pipe(filter((result) => !!result)).subscribe((result) => {
        this.avoService.trackEvent().productViewed({
          siteId: this.userService.user?.active_subscription ? "studio_one_plus" : "mypresonus",
          name: this.rawProduct.title,
          locale: (this.user?.language_code || "en") + "-" + (this.user?.country || "US"),
          productId: this.rawProduct.id.toString(),
          category: this.rawProduct.categoryId,
          sku: this.rawProduct.id.toString(),
        });
      });
    });
  }

  playSample(smp, i?) {
    let playlistFiles = [];
    this.details.product_data.cms_info.soundSamples.forEach((item) => {
      playlistFiles.push({
        url: this.samplePrefix + item.file_products_audio,
        filename: item.title_products_audio,
        id: item.idproducts_audio,
      });
    });
    this.eventBusService.emit(this.eventBusService.types.playAudio, {
      url: this.samplePrefix + smp.file_products_audio,
      filename: smp.title_products_audio,
      id: smp.idproducts_audio,
      playlist: playlistFiles,
    });
  }

  imageClick() {
    this.checkForSplash().then((result) => {});
  }

  checkForSplash() {
    return new Promise((resolve, reject) => {
      this.fbService
        .handleFirestorePromise(() => this.db.collection("product_splashes").doc(this.details.product_data.product.stringId).ref.get())
        .then((regularResult) => {
          if (this.userService.user.active_subscription) {
            this.db
              .collection("product_splashes")
              .doc(this.details.product_data.product.stringId + "_sphere")
              .ref.get()
              .then((sphereResult) => {
                if (sphereResult.exists) {
                  let sphereData: any = sphereResult.data();
                  sphereData.string_id = sphereResult.id;
                  this.showSplash(sphereData);
                  resolve(true);
                } else if (regularResult.exists) {
                  let regularData: any = regularResult.data();
                  regularData.string_id = regularResult.id;
                  this.showSplash(regularData);
                  resolve(true);
                } else {
                  resolve(false);
                }
              })
              .catch(() => {});
          } else {
            if (regularResult.exists) {
              let regularData: any = regularResult.data();
              regularData.string_id = regularResult.id;
              this.showSplash(regularData);
              resolve(true);
            } else {
              resolve(false);
            }
          }
        })
        .catch(() => {});
    });
  }

  goBack() {
    this.router.navigate(["/products/all"]);
  }

  buy() {
    const modalRef = this.appService.showModal(UpgradeSoftwareStripeComponent, {
      size: "xl",
      backdrop: "static",
    });
    modalRef.componentInstance.upgradableProducts = this.checkoutService.upgradableProducts;
  }

  showSplash(splash) {
    const modalRef = this.appService.showModal(RegisterSuccessSplashComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
    modalRef.componentInstance.splash = splash;
    modalRef.componentInstance.productId = this.details.product_data.product.id;
    modalRef.componentInstance.productName = this.rawProduct.title;
  }

  copyLink(video, event) {
    this._clipboardService.copy(environment.mypresonusUrl + "content/productvideos/" + this.details.product_data.product.stringId + "/" + video.service_id_videos);
    event.stopPropagation();
  }

  showVideo(video) {
    this.eventBusService.emit(this.eventBusService.types.playVideo, {
      id: video.service_id_videos,
      title: video.title_videos,
      type: "youtube",
      thumb: video.thumb_videos,
    });
  }

  videoClosed() {
    this.selectedVideo = undefined;
  }

  update() {
    this.group = this.productService.productGroups[this.rawProduct.stringId];
  }

  removeHardware(item) {
    this._translate.get("product_detail.confirm_remove_hardware").subscribe((string) => {
      this.win.confirm(string + "\n Serial No: " + item.hardwareSerialNumber).then(
        (_) => {
          this._spin.show();
          this.productService.deregisterHardware(item.id, true).subscribe((result) => {
            this._spin.hide();
            this.router.navigate(["products/hardware"], <NavigationExtras>{
              skipLocationChange: true,
            });
          });
        },
        (error) => {
          // console.log(error);
        }
      );
    });
  }

  showActivateOffline(item) {
    const modalRef = this.appService.showModal(ActivateOfflineComponent, { size: "sm" });
    modalRef.componentInstance.product = item;
    modalRef.componentInstance.activationCompleted.subscribe((result) => {
      if (result) {
        this.update();
      }
    });
  }

  showS16Redeem() {
    const modalRef = this.appService.showModal(Studioone6GracePeriodComponent, {
      size: "lg",
      container: this.appService.appContainer,
    });
  }

  downloadHub() {
    if (this.productService.productsByStringIDs["presonushub"]) {
      this.productService.getProductDetails(this.productService.productsByStringIDs["presonushub"]).subscribe((detail: any) => {
        if (this.appService.os == "mac") {
          this._getTokenizedInstaller(detail.product_data.product.downloads.installers.mac[0]);
        } else {
          if (detail.product_data.product.downloads.installers.win64) {
            this._getTokenizedInstaller(detail.product_data.product.downloads.installers.win64[0]);
          } else {
            this._getTokenizedInstaller(detail.product_data.product.downloads.installers.win[0]);
          }
        }
      });
    } else {
      this.productService.redeemProduct(false, "hub_id").subscribe((result) => {
        if (result.product) {
          if (this.appService.os == "mac") {
            this._getTokenizedInstaller(result.product.product.product.downloads.installers.mac[0]);
          } else {
            if (result.product.product.product.downloads.installers.win64) {
              this._getTokenizedInstaller(result.product.product.product.downloads.installers.win64[0]);
            } else {
              this._getTokenizedInstaller(result.product.product.product.downloads.installers.win[0]);
            }
          }
          this.productService.getProducts(true).subscribe();
        }
      });
    }
  }

  private _getTokenizedInstaller(dl) {
    if (dl.tokenized) {
      this.productService
        .getTokenizedUrl(
          dl.folder,
          dl.fileName,
          this.userService.appId == "mypresonus" ? "mypresonus" : "studio_one_plus",
          dl.title,
          dl.id.toString(),
          dl.fileName,
          parseInt(dl.contentLength),
          dl.version || dl.version_number
        )
        .subscribe({
          next: (result: any) => {
            window.open(result.url);
          },
          error: (error) => {
            this.appService.alertError(error);
          },
        });
    } else {
      window.open(dl.url);
    }
  }

  showTransferLicense(item) {
    const modalRef = this.appService.showModal(TransferLicenseComponent, { size: "sm" });
    modalRef.componentInstance.product = item;
  }

  showUpgrade(item) {
    const modalRef = this.appService.showModal(item.product.stringId.indexOf("studioapp") > -1 ? UpgradeSoftwareStripeComponent : UpgradeSoftwareComponent, {
      size: item.product.stringId.indexOf("studioapp") > -1 ? "xl" : "sm",
      backdrop: "static",
    });
    modalRef.componentInstance.upgradingProduct = item;
    modalRef.componentInstance.showConfirmStep = false;
    modalRef.componentInstance.couponParam = this.couponParam;
  }

  showManageActivations(item) {
    if (item.activationCount && item.product.licenseScheme != 1) {
      const modalRef = this.appService.showModal(ManageActivationsComponent, { size: "lg" });
      modalRef.componentInstance.product = item;
      modalRef.componentInstance.activationDeleted.subscribe((result) => {
        if (result.activation_id) {
          this.update();
        }
      });
    }
  }

  openOffers(item) {
    const modalRef = this.appService.showModal(RedeemHardwareOfferComponent, { size: "lg" });
    modalRef.componentInstance.parentProduct = item;
    modalRef.componentInstance.offers = item.offers;
    modalRef.componentInstance.redeemed.subscribe((result) => {
      this.initView(this._route.snapshot.params["id"]);
    });
  }

  displayDownloadSection(section) {
    if (this.downloadSections.length) {
      this.downloadSections.forEach((item) => {
        item.displayed = false;
      });
      section.displayed = true;
      this.displayedDownloadSection = section;
    }
  }

  displayResourceSection(section) {
    if (this.resourcesSections.length) {
      this.resourcesSections.forEach((item) => {
        item.displayed = false;
      });
      section.displayed = true;
      this.displayedResourcesSection = section;
    }
  }

  getOemKey(parent, item) {
    let args = {
      productid: parent.id,
      oemid: item.stringId,
    };
    item.loading = true;
    this.productService.getOemKey(args).subscribe((oemResult: GetOemKeyResponse) => {
      if (oemResult.data) item.data = oemResult.data;
      this.productService.getProducts(true).subscribe((result) => {
        item.loading = false;
      });
    });
  }

  addOptionCard() {
    let regInProcessString;
    this._translate.get("products.register.registration_in_process").subscribe((string) => {
      regInProcessString = string;
    });
    const modalRef = this.appService.showModal(RegisterProductComponent, {
      size: "lg",
      beforeDismiss: () => {
        if (modalRef.componentInstance.registering) {
          alert(regInProcessString);
          return false;
        }
      },
    });
    let asset_ids = [];
    this.group.forEach((item: any) => {
      asset_ids.push({
        serial: item.hardwareSerialNumber,
        asset_id: item.id,
      });
    });
    modalRef.componentInstance.optionCardOptions = {
      asset_ids: asset_ids,
    };
    modalRef.componentInstance.productRegistered.subscribe((result) => {
      this.setup(true);
    });
    modalRef.result.then(
      (result) => {},
      (error) => {}
    );
  }

  optionCardInstructions(card) {
    const modalRef = this.appService.showModal(FirmwareInstructionsComponent, { size: "lg" });
    modalRef.componentInstance.optionCard = card;
  }

  public removingOptionCard: boolean = false;
  deregisterOptionCard(productId) {
    this._translate.get("product_detail.option_cards.confirm_remove").subscribe((string) => {
      this.win.confirm(string).then(
        (_) => {
          this.removingOptionCard = true;
          this.productService.deregisterHardware(productId, true).subscribe((result) => {
            this.removingOptionCard = false;
            this.setup(true);
          });
        },
        (error) => {
          // console.log(error);
        }
      );
    });
  }

  tileClick(prod) {
    this.router.navigate(["products/detail/", prod.product.id]);
  }

  showiLokOverlay() {
    const modalRef = this.appService.showModal(IlokComponent, { size: "lg" });
  }
}
